/**
 * @desc 强制结束拍卖
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type ForceCloseAuctionParameter = {
  id?: string
}

const method = 'POST'
const url = '/trade/operation/auction/close'

export const forceCloseAuctionApi = (
  params?: ForceCloseAuctionParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    params,
    ...config
  })
}

forceCloseAuctionApi.method = method
forceCloseAuctionApi.url = url
